export default "__VITE_ASSET__XUn62k7UYxzryeifkYDbjg__"